import { BaseApiClient } from '@/services/baseApiClient';
import type { RequestOptions } from '@/utils/request';
import { getQuery } from '@/components/filter/helpers';
import type { SerializedNotificationSettings } from '@enmon/commons/lib/enmon';
import type { INotificationSettingsApiClient } from './types/interface';
import type {
  CreateNotificationSettingsArg,
  DeleteNotificationSettingsArg,
  GetNotificationSettingsArg,
  GetOneNotificationSettingsArg,
  UpdateNotificationSettingsArg,
} from './types/args';
import type {
  CreateNotificationSettingsResult,
  DeleteNotificationSettingsResult,
  GetNotificationSettingsResult,
  GetOneNotificationSettingsResult,
  UpdateNotificationSettingsResult,
} from './types/results';

export class NotificationSettingsApiClient extends BaseApiClient implements INotificationSettingsApiClient {
  constructor() {
    super('api/notification-settings');
  }

  public get(
    filter: GetNotificationSettingsArg,
    signal: RequestOptions['signal'],
  ): Promise<GetNotificationSettingsResult<SerializedNotificationSettings>> {
    return this.http.get('', { query: getQuery(filter), signal });
  }

  public getOne(
    id: GetOneNotificationSettingsArg,
    signal: RequestOptions['signal'],
  ): Promise<GetOneNotificationSettingsResult> {
    return this.http.get(`${id}`, { signal });
  }

  public create(arg: CreateNotificationSettingsArg): Promise<CreateNotificationSettingsResult> {
    return this.http.post('', arg);
  }

  public update({
    notificationsSettingsId,
    payload,
  }: UpdateNotificationSettingsArg): Promise<UpdateNotificationSettingsResult> {
    return this.http.put(`${notificationsSettingsId}`, payload);
  }

  public delete(id: DeleteNotificationSettingsArg): Promise<DeleteNotificationSettingsResult> {
    return this.http.delete(`${id}`);
  }
}
